
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ContraGrid extends _Ext.GridBase<ContraRow, any> {
        protected getColumnsKey() { return 'Finance.Contra'; }
        protected getDialogType() { return ContraDialog; }
        protected getIdProperty() { return ContraRow.idProperty; }
        protected getInsertPermission() { return ContraRow.insertPermission; }
        protected getLocalTextPrefix() { return ContraRow.localTextPrefix; }
        protected getService() { return ContraService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();

            var voucherNo = FormatHelper.GetVoucherNo(3);
            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<ContraRow>{
                VoucherNo: voucherNo,
                TransDate: now.toDateString(),
                UserId: userDefinition.UserId,
                EnteredBy: userDefinition.UserId.toString(),
                VoucherTypeId: 3,
                FinancialYearId: userDefinition.FinancialYearId,
                CompanyId: userDefinition.CompanyId,
                CurrencyId: userDefinition.CurrencyId,
            });
        }
    }
}